<template>
  <section class="ut-detalle" :aria-label="titulo">
    <h3 v-if="titulo">{{ titulo }}</h3>
    <template v-if="Array.isArray(datos)">
      <div v-if="datos.length" class="ut-detalle-tabla">
        <table>
          <thead><tr><th v-for="col in columnasTabla" :key="col">{{ etiqueta(col) }}</th></tr></thead>
          <tbody><tr v-for="(fila, indice) in datos.slice(0, 500)" :key="indice">
            <td v-for="col in columnasTabla" :key="col">{{ formatear(typeof fila === 'object' && fila !== null ? fila[col] : fila) }}</td>
          </tr></tbody>
        </table>
        <p v-if="datos.length > 500">{{ datos.length }} registros; se muestran los primeros 500.</p>
      </div>
      <p v-else>Sin registros.</p>
    </template>
    <template v-else-if="datos && typeof datos === 'object'">
      <dl v-if="campos.length" class="ut-datos">
        <div v-for="campo in campos" :key="campo"><dt>{{ etiqueta(campo) }}</dt><dd>{{ formatear(datos[campo], tipo(campo)) }}</dd></div>
      </dl>
      <figure v-if="firma"><img :src="firma" alt="Firma de recepcion del envio" /><figcaption>Firma de recepcion</figcaption></figure>
      <detalle-utilitario v-for="campo in grupos" :key="campo" :datos="datos[campo]" :titulo="etiqueta(campo)" :columnas="columnas" :nivel="nivel + 1" />
    </template>
    <p v-else>{{ formatear(datos) }}</p>
  </section>
</template>

<script>
import { esCampo, simple, formatear } from './catalogo';
export default {
  name: 'DetalleUtilitario',
  props: { datos: { default: null }, titulo: { type: String, default: '' }, columnas: { type: Array, default: () => [] }, nivel: { type: Number, default: 0 } },
  computed: {
    campos() { return Object.keys(this.datos || {}).filter(k => esCampo(k) && simple(this.datos[k]) && !['firma', 'firmaBase64', 'firma_base64'].includes(k)).slice(0, 100); },
    grupos() { return this.nivel < 3 ? Object.keys(this.datos || {}).filter(k => esCampo(k) && this.datos[k] && typeof this.datos[k] === 'object').slice(0, 20) : []; },
    columnasTabla() {
      const keys = [];
      this.datos.slice(0, 500).forEach(r => { if (r && typeof r === 'object') Object.keys(r).forEach(k => { if (esCampo(k) && simple(r[k]) && !keys.includes(k)) keys.push(k); }); });
      return keys.length ? keys.slice(0, 40) : ['valor'];
    },
    firma() {
      const value = this.datos && (this.datos.firma || this.datos.firmaBase64 || this.datos.firma_base64);
      if (typeof value !== 'string' || value.length > 3000000) return '';
      if (/^data:image\/(png|jpeg);base64,[A-Za-z0-9+/=\r\n]+$/.test(value)) return value;
      if (/^(iVBORw0KGgo|\/9j\/)[A-Za-z0-9+/=\r\n]+$/.test(value)) return 'data:image/' + (value.startsWith('iVBOR') ? 'png' : 'jpeg') + ';base64,' + value;
      return '';
    },
  },
  methods: {
    formatear,
    etiqueta(campo) {
      const c = this.columnas.find(c => c.campo === campo);
      const labels = { registro: 'Registro', detalles: 'Detalle', consumos: 'Consumos', boletos: 'Boletos', estadisticas: 'Estadisticas', cancelados: 'Documentos cancelados', documentosCancelados: 'Documentos cancelados', autorizaciones: 'Autorizaciones de reimpresion', resumen: 'Resumen', valores: 'Configuracion' };
      return c ? c.titulo : labels[campo] || campo.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
    },
    tipo(campo) { const c = this.columnas.find(c => c.campo === campo); return c && c.tipo; },
  },
};
</script>

<style scoped>
.ut-detalle { min-width: 0; margin: 0 0 16px; }
.ut-detalle h3 { font-size: 15px; margin: 14px 0 10px; font-weight: 700; letter-spacing: 0; }
.ut-datos { display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 12px 20px; margin: 0; }
.ut-datos div { min-width: 0; }
.ut-datos dt { color: #5d6871; font-size: 12px; font-weight: 700; overflow-wrap: anywhere; }
.ut-datos dd { margin: 3px 0 0; font-size: 14px; white-space: pre-wrap; overflow-wrap: anywhere; }
.ut-detalle-tabla { overflow: auto; max-height: 420px; border: 1px solid #d5dce1; }
.ut-detalle table { border-collapse: collapse; width: 100%; font-size: 13px; }
.ut-detalle th, .ut-detalle td { text-align: left; padding: 8px 12px; border-bottom: 1px solid #d5dce1; white-space: pre-wrap; min-width: 110px; max-width: 300px; overflow-wrap: anywhere; }
.ut-detalle th { position: sticky; top: 0; background: #f3f5f6; font-weight: 700; }
.ut-detalle img { display: block; max-width: 100%; max-height: 220px; object-fit: contain; }
.ut-detalle figure { margin: 12px 0; }
.ut-detalle figcaption { color: #5d6871; font-size: 12px; }
</style>
